<template>
  <div>
    <!-- Basic Details -->
    <basic-details
      :matter="$store.state.matterStore.currentmatter"
    ></basic-details>
    <!-- Case Status -->
    <tribunals-status
      :matter="$store.state.matterStore.currentmatter"
    ></tribunals-status>

    <!-- Complainant Against Detail -->
    <div class="mb-1" v-if="hasRcTrcCaseDetails">
      <DynamicObjectDetail
        :data="$store.state.matterStore.currentmatter.rc_trc_case_details"
        :title="'RC/TRC Case Details'"
      ></DynamicObjectDetail>
    </div>
    <!-- Linked Matters -->
    <div v-if="hasLinkedMatters">
      <linked-matters
        :matter="$store.state.matterStore.currentmatter"
      ></linked-matters>
    </div>
    <!-- Peitioner & Respondent -->
    <div
    >
      <petitioner-respondents
        :matter="$store.state.matterStore.currentmatter"
      ></petitioner-respondents>
    </div>
    <!-- Reference Case Details -->
    <div v-if="hasReferenceCaseDetails">
      <reference-case-details
        :matter="$store.state.matterStore.currentmatter"
      ></reference-case-details>
    </div>
    <!-- Document Filing Details -->
    <div v-if="hasDocumentDetails">
      <document-filing-details
        :matter="$store.state.matterStore.currentmatter"
      ></document-filing-details>
    </div>
    <!-- Listening History -->
    <div v-if="hasCaseProceeding">
      <case-proceeding
        :matter="$store.state.matterStore.currentmatter"
      ></case-proceeding>
    </div>

    <!-- Listening History -->
    <div v-if="hasListingHistory">
      <listing-details
        :matter="$store.state.matterStore.currentmatter"
      ></listing-details>
    </div>

    <!-- Orders -->
    <div v-if="hasTabularOrders">
      <tabular-orders
        :matter="$store.state.matterStore.currentmatter"
      ></tabular-orders>
    </div>
    <!-- Complainant Against Detail -->
    <div class="mb-1" v-if="hasComplainantAgainstDetail">
      <DynamicObjectDetail
        :data="
          $store.state.matterStore.currentmatter.complainant_against_detail
        "
        :title="'Complainant Against Detail'"
      ></DynamicObjectDetail>
    </div>
    <b-row>
      <!-- Complainant Detail -->
      <b-col
        class="col-12 col-md-6 mb-1"
        v-if="hasComplainantDetail"
      >
        <DynamicObjectDetail
          :data="$store.state.matterStore.currentmatter.complainant_detail"
          :title="'Complainant Detail'"
        ></DynamicObjectDetail>
      </b-col>
      <!-- Complainant Detail -->
      <b-col
        class="col-12 col-md-6 mb-1"
        v-if="hasComplaintDetail"
      >
        <DynamicObjectDetail
          :data="$store.state.matterStore.currentmatter.complaint_detail"
          :title="'Complaint Details'"
        ></DynamicObjectDetail>
      </b-col>
    </b-row>
    <!-- complaints_ground -->
    <div class="mb-1" v-if="hasComplaintsGround">
      <DynamicListTable
        :data="$store.state.matterStore.currentmatter.complaints_ground"
        title="Complaints Ground"
      ></DynamicListTable>
    </div>

    <div class="mb-1" v-if="hasPaymentMadeToPromoter">
      <DynamicListTable
        :data="$store.state.matterStore.currentmatter.payment_made_to_promoter"
        title="Payment Made to Promoter"
      ></DynamicListTable>
    </div>

    <!-- RC/TRC Listing History -->
    <div v-if="hasRcTrcListingHistory">
      <DynamicListTable
        :data="$store.state.matterStore.currentmatter.rc_trc_listing_history"
        title="RC/TRC Listing History"
      ></DynamicListTable>
    </div>

    <!-- IA Details -->
    <div v-if="hasIaDetails">
      <DynamicListTable
        :data="$store.state.matterStore.currentmatter.ia"
        title="IA Details"
      ></DynamicListTable>
    </div>

    <!-- Inferior Court wise details -->
    <h3 v-if="hasInferiorCourtWiseDetails" class="pb-1">Inferior Court wise details</h3>
    <b-card no-body v-if="hasInferiorCourtWiseDetails">
      <app-collapse accordion>
        <app-collapse-item
          title="Divisional Level"
          v-if="hasInferiorDivisionalLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .inferior_court_wise_details_of_cases_divisional_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item
          title="District Level"
          v-if="hasInferiorTehsilLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .inferior_court_wise_details_of_cases_tehsil_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item
          title="Tahsil Level"
          v-if="hasInferiorDistrictLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .inferior_court_wise_details_of_cases_district_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
      </app-collapse>
    </b-card>

    <!-- Other claims registered on the plot/gate in question -->
    <h3 v-if="hasOtherClaimsDetails" class="pb-1">Other claims registered on the plot/gate in question</h3>
    <b-card no-body v-if="hasOtherClaimsDetails">
      <app-collapse accordion>
        <app-collapse-item
          title="Divisional Level"
          v-if="hasOtherClaimsDivisionalLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .details_of_other_claims_registered_on_the_plot_divisional_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item
          title="District Level"
          v-if="hasOtherClaimsDistrictLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .details_of_other_claims_registered_on_the_plot_district_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item
          title="Tahsil Level"
          v-if="hasOtherClaimsTehsilLevel"
        >
          <DynamicListTable
            :data="
              $store.state.matterStore.currentmatter
                .details_of_other_claims_registered_on_the_plot_tehsil_level
            "
            title=""
          ></DynamicListTable>
        </app-collapse-item>
      </app-collapse>
    </b-card>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
// Section Imports
import BasicDetails from './components/basic-details/BasicDetails.vue'
import TribunalsStatus from './components/status/TribunalsStatus.vue'
import DocumentFilingDetails from './components/DocumentFilingDetails.vue'
import CaseProceeding from './components/CaseProceeding.vue'
import PetitionerRespondents from './components/petitioner-respondent/PetitionerRespondents.vue'
import ReferenceCaseDetails from './components/ReferenceCaseDetails.vue'
import LinkedMatters from './components/LinkedMatters.vue'
import TribunalOrders from './components/orders/TribunalOrders.vue'
import ListingDetails from './components/listing-history/ListingDetails.vue'
import TabularOrders from './components/listing-history/TabularOrders.vue'
import DynamicObjectDetail from './components/DynamicObjectDetail.vue'
import DynamicListTable from './components/DynamicListTable.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import CollapseListItem from './components/CollapseListItem.vue'

export default {
  computed: {
    currentMatter() {
      return this.$store.state.matterStore.currentmatter || {}
    },
    hasRcTrcCaseDetails() {
      return this.hasAnyData(this.currentMatter.rc_trc_case_details)
    },
    hasLinkedMatters() {
      return this.hasAnyData(this.currentMatter.linked_matters)
    },
    hasReferenceCaseDetails() {
      return this.hasAnyData(this.currentMatter.reference_case_details)
    },
    hasDocumentDetails() {
      return this.hasAnyData(this.currentMatter.document_details)
    },
    hasCaseProceeding() {
      return this.hasAnyData(this.currentMatter.case_proceeding)
    },
    hasListingHistory() {
      return this.hasAnyData(this.currentMatter.listing_history)
    },
    hasTabularOrders() {
      return this.hasAnyData(this.currentMatter.tabular_orders)
    },
    hasComplainantAgainstDetail() {
      return this.hasAnyData(this.currentMatter.complainant_against_detail)
    },
    hasComplainantDetail() {
      return this.hasAnyData(this.currentMatter.complainant_detail)
    },
    hasComplaintDetail() {
      return this.hasAnyData(this.currentMatter.complaint_detail)
    },
    hasComplaintsGround() {
      return this.hasAnyData(this.currentMatter.complaints_ground)
    },
    hasPaymentMadeToPromoter() {
      return this.hasAnyData(this.currentMatter.payment_made_to_promoter)
    },
    hasRcTrcListingHistory() {
      return this.hasAnyData(this.currentMatter.rc_trc_listing_history)
    },
    hasIaDetails() {
      return this.hasAnyData(this.currentMatter.ia)
    },
    hasInferiorDivisionalLevel() {
      return this.hasAnyData(
        this.currentMatter.inferior_court_wise_details_of_cases_divisional_level
      )
    },
    hasInferiorTehsilLevel() {
      return this.hasAnyData(
        this.currentMatter.inferior_court_wise_details_of_cases_tehsil_level
      )
    },
    hasInferiorDistrictLevel() {
      return this.hasAnyData(
        this.currentMatter.inferior_court_wise_details_of_cases_district_level
      )
    },
    hasInferiorCourtWiseDetails() {
      return (
        this.hasInferiorDivisionalLevel ||
        this.hasInferiorTehsilLevel ||
        this.hasInferiorDistrictLevel
      )
    },
    hasOtherClaimsDivisionalLevel() {
      return this.hasAnyData(
        this.currentMatter
          .details_of_other_claims_registered_on_the_plot_divisional_level
      )
    },
    hasOtherClaimsDistrictLevel() {
      return this.hasAnyData(
        this.currentMatter
          .details_of_other_claims_registered_on_the_plot_district_level
      )
    },
    hasOtherClaimsTehsilLevel() {
      return this.hasAnyData(
        this.currentMatter
          .details_of_other_claims_registered_on_the_plot_tehsil_level
      )
    },
    hasOtherClaimsDetails() {
      return (
        this.hasOtherClaimsDivisionalLevel ||
        this.hasOtherClaimsDistrictLevel ||
        this.hasOtherClaimsTehsilLevel
      )
    }
  },
  methods: {
    hasAnyData(value) {
      if (Array.isArray(value)) return value.length > 0
      if (value && typeof value === 'object') return Object.keys(value).length > 0
      return value !== null && value !== undefined && value !== ''
    }
  },
  components: {
    BRow,
    BCol,
    BCard,
    // Basic Details
    BasicDetails,
    DocumentFilingDetails,
    TribunalsStatus,
    CaseProceeding,
    PetitionerRespondents,
    ReferenceCaseDetails,
    LinkedMatters,
    TribunalOrders,
    ListingDetails,
    TabularOrders,
    DynamicObjectDetail,
    DynamicListTable,
    AppCollapse,
    AppCollapseItem,
    CollapseListItem
  }
}
</script>
